var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoostProfiling = function SvgBoostProfiling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 251,
    height: 164,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2BD675",
    filter: "url(#Boost_Profiling_svg__a)",
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 82,
    r: 25.5,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M41.951 82h-5.1l-3.825 11.475-7.65-22.95L21.551 82h-5.1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Boost_Profiling_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 133.5,
    r: 17,
    stroke: "#2BD675"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD675",
    d: "M69.546 127.98a2.16 2.16 0 0 1 3.12.17 2.33 2.33 0 0 1-.165 3.218l-7.363 6.838a2.16 2.16 0 0 1-2.956 0l-3.683-3.419a2.33 2.33 0 0 1-.164-3.219 2.16 2.16 0 0 1 2.945-.316l.175.147 2.203 2.046z",
    opacity: 0.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2BD675",
    d: "M114.967 32.37C102.962 45.431 95.632 62.86 95.632 82c0 14.713 4.332 28.414 11.788 39.898l30.896-28.808-10.649-8.424c-4.526-3.58-3.019-10.792 2.562-12.26l51.844-13.634c4.572-1.201 8.996 2.38 8.773 7.101l-2.557 54.005c-.272 5.736-6.955 8.723-11.41 5.1l-8.937-7.271-23.563 33.426A73.2 73.2 0 0 0 169 155.368c20.215 0 38.519-8.176 51.789-21.401v11.61C206.669 157.093 188.641 164 169 164c-45.287 0-82-36.713-82-82 0-18.654 6.23-35.853 16.722-49.63zm23.614 48.179 8.68 6.864c3.361 2.659 3.564 7.687.429 10.61l-34.231 31.917a73.7 73.7 0 0 0 21.823 17.237c.15-.533.391-1.05.728-1.529l25.611-36.329.226-.303a7 7 0 0 1 9.613-1.325l.3.231 6.82 5.548 2.082-43.988z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Boost_Profiling_svg__a",
    width: 62,
    height: 62,
    x: 0,
    y: 51,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_6170_742",
    stdDeviation: 2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Boost_Profiling_svg__b",
    width: 43,
    height: 43,
    x: 44,
    y: 112,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_6170_742",
    stdDeviation: 2
  })))));
};
export default SvgBoostProfiling;